import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button, Radio, Input, TextArea, Checkbox } from 'semantic-ui-react';

import * as com_action from 'actions/company';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

class NoticeAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: 'N',
      isPush: false,
      title: '',
      content: '',
      textCount: 0
    };
  }

  //입력 값 변경
  handleChange = async (e, { name, value }) => {
    let result = value;

    if (['title', 'content'].indexOf(name) > -1) {
      let result = value;
      if (name === 'content') {
        if (result.length > 0 && result.length > 2000) {
          toastr('top-right', 'warning', '2000자 이하로 입력해주세요.');
          result = result.substring(0, 2000);
        }
        this.setState({ textCount: result.length });
      } else if (name === 'title') {
        if (result.length > 0 && result.length > 30) {
          toastr('top-right', 'warning', '30자 이하로 입력해주세요.');
          result = result.substring(0, 30);
        }
      }
      this.setState({ [name]: result });
    } else if (name === 'isPush') {
      await this.setState({ isPush: result });
    } else {
      await this.setState({ isOpen: result });
    }
    console.log(this.state);
  };

  //공지사항 추가
  handleSubmit = async (e) => {
    e.preventDefault();
    const { isOpen, isPush, title, content } = this.state;

    let status = isOpen === 'Y' ? true : false;

    if (cm.valueCheck(title)) {
      toastr('top-right', 'warning', '제목을 입력해주세요.');
    } else if (title.length > 30) {
      toastr('top-right', 'warning', '30자 이하로 입력해주세요.');
    } else if (cm.valueCheck(content)) {
      toastr('top-right', 'warning', '내용을 입력해주세요.');
    } else if (content.length > 2000) {
      toastr('top-right', 'warning', '2000자 이하로 입력해주세요.');
    } else {
      try {
        const params = {
          notice: {
            status: status,
            push: isPush,
            title: title,
            content: content
          }
        };

        const { comAPI } = this.props;
        console.log(params);
        await comAPI.noticeAdd(params);

        const { result } = this.props;
        const { moveToList } = this.props.AddFn;
        moveToList();
        this.setState({
          isOpen: 'N',
          isPush: false,
          title: '',
          content: ''
        });

        toastr('top-right', 'success', '공지사항이 등록되었습니다.');
      } catch (e) {
        toastr('top-right', 'error', '일시적인 오류로 공지사항을 등록하지 못했습니다. 다시 시도해주세요.22');
      }
    }
  };

  handleCancel = () => {
    this.setState({
      isOpen: 'N',
      isPush: false,
      title: '',
      content: ''
    });

    const { moveToList } = this.props.AddFn;
    moveToList();
  };

  render() {
    const { isOpen, isPush, title, content, textCount } = this.state;

    return (
      <div>
        <div className="notice_row">
          <div className="notice_tit">공개여부</div>
          <div className="notice_cont">
            <Radio label="노출함" name="isOpen1" value="Y" checked={'Y' === isOpen} onChange={this.handleChange} />
            <Radio label="노출 안함" name="isOpen2" value="N" checked={'N' === isOpen} onChange={this.handleChange} />
            {this.state.isOpen === 'Y' && (
              <Checkbox
                style={{ paddingLeft: '20px' }}
                label="PUSH 발송"
                name="isPush"
                value={!isPush}
                checked={isPush}
                onChange={this.handleChange}
              />
            )}
          </div>
        </div>
        <div className="notice_row">
          <div className="notice_tit">제목</div>
          <div className="notice_cont">
            <Input name="title" value={title} onChange={this.handleChange} placeholder="30자 이하로 입력해주세요" />
          </div>
        </div>
        <div className="notice_row">
          <div className="notice_tit">
            <span>내용</span>
            <span style={{ position: 'fixed', right: '30px' }}>{textCount + ' / 2000자'}</span>
          </div>

          <TextArea
            name="content"
            value={content}
            onChange={this.handleChange}
            placeholder="2000자 이하로 입력해주세요"
            maxLength={2001}
          />
        </div>
        <div className="notice_row btn-group">
          <Button inverted color="grey" onClick={this.handleCancel} content="취소" />
          <Button positive content="완료" onClick={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

NoticeAdd = connect(
  (state) => ({
    result: state.company.result
  }),
  (dispatch) => ({
    comAPI: bindActionCreators(
      {
        noticeAdd: com_action.NoticeAdd
      },
      dispatch
    )
  })
)(NoticeAdd);

export default NoticeAdd;
